<template>
  <el-card>
    <div class="loading-page">
      <img :src="logo" class="loading-page__logo"/>
      <h1 class="loading-page__h1">{{ $t('redirect.title') }}</h1>
      <h3 class="loading-page__h3">{{ $t('redirect.subtitle') }}</h3>
      <div class="loading-page__loading">
        <div class="loading-page__loading__cube loading-page__loading__cube--1"></div>
        <div class="loading-page__loading__cube loading-page__loading__cube--2"></div>
        <div class="loading-page__loading__cube loading-page__loading__cube--3"></div>
        <div class="loading-page__loading__cube loading-page__loading__cube--4"></div>
        <div class="loading-page__loading__cube loading-page__loading__cube--5"></div>
        <div class="loading-page__loading__cube loading-page__loading__cube--6"></div>
        <div class="loading-page__loading__cube loading-page__loading__cube--7"></div>
        <div class="loading-page__loading__cube loading-page__loading__cube--8"></div>
        <div class="loading-page__loading__cube loading-page__loading__cube--9"></div>
      </div>
    </div>
  </el-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import cookie from '@nextories/vue-core-components/src/utils/helpers/cookie';
import logoNextories from '@/assets/img/logo-nextories.png';

export default {
  name: 'redirect',
  data() {
    return {
      continue: true,
    };
  },
  computed: {
    ...mapGetters({
      projectIdSelected: 'projectStore/projectIdSelected',
      projects: 'projectStore/projects',
    }),
    logo() {
      return logoNextories;
    },
  },
  methods: {
    ...mapActions({
      setProjectSelected: 'projectStore/setProjectSelected',
      getSignature: 'comparatorStore/getSignature',
    }),
    callSignature() {
      this.getSignature().then((data) => {
        if (data) {
          if (data.is_finished) {
            this.$store.dispatch('actionsStore/track', 'bookSigned');
            // TODO voir vers quelle page on redirige maintenant
            if (data.is_first_signature) {
              this.$router.push({ name: 'booking', params: { id: data.offer_id }, hash: '#confirm' });
            } else {
              this.$router.push({ name: 'procedures' });
            }
          } else if (!this.continue) {
            // TODO SHOW ERROR TIMEOUT?
            this.$router.push({ name: 'comparator' });
          } else {
            setTimeout(() => {
              this.callSignature();
            }, 1000 * 3);
          }
        }
      }).catch((error) => {
        // eslint-disable-next-line no-console
        console.error(error);
        this.$router.push({ name: 'comparator' });
      });
    },
  },
  created() {
    const token = cookie.getCookie(process.env.VUE_APP_COOKIE_REDIRECT_NAME);
    if (token) {
      cookie.deleteCookie(process.env.VUE_APP_COOKIE_REDIRECT_NAME);
      const projectSelected = this.projects.find((project) => project.token === token);
      if (projectSelected) {
        if (token !== this.projectIdSelected) {
          this.setProjectSelected(projectSelected);
        }
        setTimeout(() => {
          this.continue = false;
        }, 1000 * 30);
        this.callSignature();
        return;
      }
    }
    this.$router.push({ name: 'comparator' });
  },
};
</script>

<style scoped lang="scss">

.loading-page {
  margin: 50px 0;
  height: calc(100vh - 142px);
  text-align: center;
  &__logo {
    width: 80%;
    @include breakpoint(mobile) {
      width: inherit;
    }
  }
  &__h1 {
    margin: 20px 0 10px;
  }
  &__h3 {
    margin: 10px 0 20px
  }
  &__loading {
    width: 80px;
    height: 80px;
    margin: 20px auto;
    &__cube {
      width: 33.333%;
      height: 33.333%;
      background-color: $--color-secondary;
      float: left;
      -webkit-animation: sk-cubeGridScaleDelay 1.3s infinite ease-in-out;
      animation: sk-cubeGridScaleDelay 1.3s infinite ease-in-out;
      &--1 {
        -webkit-animation-delay: 0.2s;
        animation-delay: 0.2s;
      }
      &--2 {
        -webkit-animation-delay: 0.3s;
        animation-delay: 0.3s;
      }
      &--3 {
        -webkit-animation-delay: 0.3s;
        animation-delay: 0.3s;
      }
      &--4 {
        -webkit-animation-delay: 0.1s;
        animation-delay: 0.1s;
      }
      &--5 {
        -webkit-animation-delay: 0.2s;
        animation-delay: 0.2s;
      }
      &--6 {
        -webkit-animation-delay: 0.3s;
        animation-delay: 0.3s;
      }
      &--7 {
        -webkit-animation-delay: 0s;
        animation-delay: 0s;
      }
      &--8 {
        -webkit-animation-delay: 0.1s;
        animation-delay: 0.1s;
      }
      &--9 {
        -webkit-animation-delay: 0.2s;
        animation-delay: 0.2s;
      }
    }
  }

}
@-webkit-keyframes sk-cubeGridScaleDelay {
  0%, 70%, 100% {
    -webkit-transform: scale3D(1, 1, 1);
    transform: scale3D(1, 1, 1);
  } 35% {
    -webkit-transform: scale3D(0, 0, 1);
    transform: scale3D(0, 0, 1);
  }
}

@keyframes sk-cubeGridScaleDelay {
  0%, 70%, 100% {
    -webkit-transform: scale3D(1, 1, 1);
    transform: scale3D(1, 1, 1);
  } 35% {
    -webkit-transform: scale3D(0, 0, 1);
    transform: scale3D(0, 0, 1);
  }
}

</style>
